/**
 * Batch #14.252 — Illustrations SVG inline des guides « Paie » et « Entreprise » (portail).
 * Même style que WebGuideIllustrations (cadre navigateur). Schéma : { [slug]: SVGComponent }
 */
import { Frame, T, Pill as BasePill } from "./WebGuideIllustrations";

// Coercition numérique : les props x/y/w peuvent être passées en chaînes
const Pill = ({ x, y, w = 60, ...rest }) => <BasePill x={+x} y={+y} w={+w} {...rest} />;

const W = 1200;

const Card = ({ x, y, w, h, children }) => (
  <g>
    <rect x={x} y={y} width={w} height={h} rx="12" fill="white" stroke="#E2E8F0" filter="url(#shadow)" />
    {children}
  </g>
);

const Input = ({ x: x0, y: y0, w: w0 = 140, label, value, muted = false }) => {
  const x = +x0, y = +y0, w = +w0;
  return (
  <g>
    <T x={x} y={y} size="10" w="600" color="#64748B">{label}</T>
    <rect x={x} y={y + 6} width={w} height="30" rx="7" fill={muted ? "#F8FAFC" : "white"} stroke="#CBD5E1" />
    <T x={x + 10} y={y + 26} size="12" w="500" color={muted ? "#94A3B8" : "#1E293B"}>{value}</T>
  </g>
  );
};

const Tabs = ({ y: y0, active }) => {
  const y = +y0;
  const tabs = ["Feuilles de temps", "Employés", "Documents reçus", "DAS"];
  return tabs.map((t, i) => (
    <g key={t}>
      <rect x={40 + i * 175} y={y} width="165" height="34" rx="9" fill={t === active ? "#D97706" : "white"} stroke={t === active ? "#D97706" : "#E2E8F0"} />
      <T x={122 + i * 175} y={y + 22} size="12" w="600" color={t === active ? "white" : "#475569"} anchor="middle">{t}</T>
    </g>
  ));
};

const Hero = ({ title, subtitle, sub2 }) => (
  <g>
    <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
    <T x="40" y="80" size="22" w="700" color="white">{title}</T>
    <T x="40" y="102" size="13" color="#FDE68A">{subtitle}</T>
    {sub2 && <Pill x="1010" y="68" w="150" label={sub2} fill="white" textFill="#B45309" />}
  </g>
);

// ============================================================
//  PAIE — paie-employes
// ============================================================
export function PaieEmployes() {
  const emps = [
    { name: "Jean Tremblay", no: "E001", job: "Charpentier-menuisier · CCQ", freq: "Aux 2 semaines · 80 h", pay: "Dépôt direct •••4321", badge: null },
    { name: "Marie Gagnon", no: "E002", job: "Adjointe administrative", freq: "Aux 2 semaines · salaire", pay: "Dépôt direct •••8810", badge: null },
    { name: "Karim Bensaïd", no: "E003", job: "Apprenti électricien", freq: "Hebdomadaire · 40 h", pay: "Chèque", badge: "En vérification" },
  ];
  return (
    <Frame accent="#D97706">
      <Hero title="💰 Paie" subtitle="Les Entreprises Tremblay inc. · Année 2026" sub2="3 employés actifs" />
      <Tabs y="140" active="Employés" />
      <Card x="40" y="196" w="1120" h="480">
        <T x="70" y="232" size="15" w="700" color="#1E293B">Mes employés</T>
        <Pill x="960" y="214" w="170" label="+ Ajouter un employé" fill="#D97706" />
        {emps.map((e, i) => (
          <g key={i}>
            <line x1="40" y1={262 + i * 110} x2="1160" y2={262 + i * 110} stroke="#F1F5F9" />
            <circle cx="90" cy={312 + i * 110} r="22" fill="#FEF3C7" />
            <T x="90" y={318 + i * 110} size="14" w="700" color="#B45309" anchor="middle">{e.name.split(" ").map((p) => p[0]).join("")}</T>
            <T x="130" y={304 + i * 110} size="15" w="700" color="#1E293B">{e.name}</T>
            <T x="130" y={326 + i * 110} size="12" color="#64748B">{e.no} · {e.job}</T>
            <T x="620" y={304 + i * 110} size="12" color="#475569">{e.freq}</T>
            <T x="620" y={326 + i * 110} size="12" color="#475569">{e.pay}</T>
            {e.badge && <Pill x="900" y={296 + i * 110} w="120" label={e.badge} fill="#FEF3C7" textFill="#92400E" />}
            <Pill x="1050" y={296 + i * 110} w="80" label="Modifier" fill="white" textFill="#D97706" />
          </g>
        ))}
        <rect x="70" y="600" width="1060" height="56" rx="10" fill="#FFFBEB" stroke="#FDE68A" />
        <T x="90" y="624" size="12" w="700" color="#92400E">Bon à savoir</T>
        <T x="90" y="642" size="12" color="#92400E">Votre gestionnaire complète les crédits d'impôt (TD1 / TP-1015.3), le % de vacances et les retenues récurrentes — vous n'avez rien à calculer.</T>
      </Card>
    </Frame>
  );
}

// ============================================================
//  PAIE — paie-feuille-temps
// ============================================================
export function PaieFeuilleTemps() {
  const hours = [["Régulières", "80"], ["Temps et demi", "4"], ["Temps double", "0"], ["Férié payé", "8"], ["Maladie", "0"], ["Vacances (h)", "0"]];
  return (
    <Frame accent="#D97706">
      <Hero title="💰 Paie" subtitle="Feuille de temps · 2026-09-01 → 2026-09-14 · paie le 2026-09-18" sub2="En saisie" />
      <Tabs y="140" active="Feuilles de temps" />
      <Card x="40" y="196" w="1120" h="480">
        <T x="70" y="228" size="15" w="700" color="#1E293B">Jean Tremblay</T>
        <T x="70" y="246" size="11" color="#94A3B8">E001 · Horaire · 80 h / période</T>
        <T x="1130" y="232" size="11" w="600" color="#D97706" anchor="end">☐ Aucune paie cette période</T>
        {hours.map(([l, v], i) => <Input key={l} x={70 + (i % 6) * 178} y={262} w="160" label={l} value={v} />)}
        <T x="70" y="334" size="12" w="600" color="#D97706">▾ Boni, retenues, notes…</T>
        <Input x="70" y="350" w="160" label="Boni ($)" value="250,00" />
        <Input x="248" y="350" w="160" label="Commission ($)" value="0,00" />
        <Input x="426" y="350" w="160" label="Paie de vacances ($)" value="0,00" />
        <T x="70" y="418" size="11" w="700" color="#475569">Autres gains exceptionnels</T>
        <Input x="70" y="426" w="400" label="" value="Prime de rendement" />
        <Input x="482" y="426" w="104" label="" value="100,00" />
        <T x="640" y="418" size="11" w="700" color="#475569">Retenues exceptionnelles</T>
        <Input x="640" y="426" w="360" label="" value="Avance du 5 septembre" />
        <Input x="1012" y="426" w="104" label="" value="50,00" />
        <Input x="70" y="484" w="1046" label="Note pour cet employé (optionnel)" value="Absent le 12 septembre — journée non payée" muted />
        <Input x="70" y="540" w="760" label="Note pour cette paie (visible par votre gestionnaire)" value="Merci de traiter avant jeudi midi" muted />
        <Pill x="850" y="560" w="130" label="💾 Enregistrer" fill="white" textFill="#D97706" />
        <Pill x="992" y="560" w="130" label="✈ Soumettre" fill="#D97706" />
        <rect x="70" y="612" width="1046" height="44" rx="10" fill="#F0F9FF" stroke="#BAE6FD" />
        <T x="90" y="639" size="12" color="#075985">Aucun montant de paie n'est calculé ici : votre gestionnaire applique les retenues et vous transmet les documents.</T>
      </Card>
    </Frame>
  );
}

// ============================================================
//  PAIE — paie-documents
// ============================================================
export function PaieDocuments() {
  const docs = ["📄 Bulletins de paie (PDF)", "🧾 Chèques (PDF)", "🏦 Fichier bancaire CPA-005", "📊 Registre (Excel)"];
  return (
    <Frame accent="#D97706">
      <Hero title="💰 Paie" subtitle="Documents transmis par votre gestionnaire" sub2="2 périodes" />
      <Tabs y="140" active="Documents reçus" />
      <Card x="40" y="196" w="1120" h="480">
        <T x="70" y="232" size="15" w="700" color="#1E293B">Documents reçus</T>
        {[0, 1].map((i) => (
          <g key={i}>
            <rect x="70" y={256 + i * 200} width="1060" height="180" rx="12" fill={i === 0 ? "#FFFBEB" : "white"} stroke={i === 0 ? "#FDE68A" : "#E2E8F0"} />
            <T x="90" y={286 + i * 200} size="14" w="700" color="#1E293B">Période du {i === 0 ? "2026-09-01 au 2026-09-14" : "2026-08-18 au 2026-08-31"}</T>
            <T x="90" y={306 + i * 200} size="12" color="#64748B">Paie le {i === 0 ? "2026-09-18" : "2026-09-04"} · transmis le {i === 0 ? "2026-09-16" : "2026-09-02"}</T>
            {i === 0 && <Pill x="1010" y={272} w="100" label="Nouveau" fill="#D97706" />}
            {i === 0 && (
              <g>
                <rect x="90" y={320} width="1020" height="34" rx="8" fill="white" stroke="#FDE68A" />
                <T x="104" y={342} size="12" color="#92400E">💬 « Déposez le fichier bancaire à votre caisse avant jeudi 15 h. » — votre gestionnaire</T>
              </g>
            )}
            {docs.slice(0, i === 0 ? 4 : 2).map((d, j) => (
              <g key={j}>
                <rect x={90 + j * 258} y={i === 0 ? 372 : 330} width="246" height="40" rx="9" fill="white" stroke="#D97706" />
                <T x={213 + j * 258} y={i === 0 ? 397 : 355} size="12" w="600" color="#B45309" anchor="middle">{d}</T>
              </g>
            ))}
          </g>
        ))}
      </Card>
    </Frame>
  );
}

// ============================================================
//  PAIE — paie-das
// ============================================================
export function PaieDas() {
  const rows = [["Impôt du Québec retenu", "1 200,00 $"], ["RRQ — part salarié", "300,00 $"], ["RRQ — part employeur", "300,00 $"], ["RQAP — part salarié", "40,00 $"], ["RQAP — part employeur", "56,00 $"], ["FSS (Fonds des services de santé)", "150,00 $"]];
  return (
    <Frame accent="#D97706">
      <Hero title="💰 Paie" subtitle="Remises DAS publiées par votre gestionnaire" />
      <Tabs y="140" active="DAS" />
      <Card x="40" y="196" w="1120" h="480">
        <Input x="70" y="214" w="120" label="Année" value="2026" />
        <Input x="210" y="214" w="200" label="Mois" value="Octobre ●" />
        <T x="440" y="224" size="10" w="600" color="#64748B">Palier</T>
        <rect x="440" y="230" width="300" height="30" rx="8" fill="white" stroke="#CBD5E1" />
        <rect x="441" y="231" width="150" height="28" rx="7" fill="#D97706" />
        <T x="516" y="250" size="12" w="600" color="white" anchor="middle">Provincial (RQ)</T>
        <T x="666" y="250" size="12" w="600" color="#475569" anchor="middle">Fédéral (ARC)</T>
        <rect x="70" y="282" width="1060" height="370" rx="12" fill="white" stroke="#E2E8F0" />
        <T x="90" y="312" size="15" w="700" color="#1E293B">Octobre 2026 — Provincial (Revenu Québec)</T>
        <Pill x="960" y="294" w="150" label="✔ Publié par votre gestionnaire" fill="#DCFCE7" textFill="#166534" />
        {rows.map(([l, v], i) => (
          <g key={l}>
            <line x1="90" y1={330 + i * 38} x2="1110" y2={330 + i * 38} stroke="#F1F5F9" />
            <T x="100" y={355 + i * 38} size="13" color="#334155">{l}</T>
            <T x="1100" y={355 + i * 38} size="13" w="600" color="#1E293B" anchor="end">{v}</T>
          </g>
        ))}
        <rect x="90" y="560" width="1020" height="40" rx="8" fill="#FFFBEB" />
        <T x="100" y="586" size="14" w="700" color="#92400E">TOTAL À REMETTRE</T>
        <T x="1100" y="586" size="16" w="700" color="#92400E" anchor="end">2 046,00 $</T>
        <T x="90" y="630" size="12" color="#64748B">Échéance du versement : <tspan fontWeight="700" fill="#1E293B">2026-11-15</tspan></T>
        <Pill x="960" y="612" w="150" label="⬇ Télécharger en PDF" fill="#D97706" />
      </Card>
    </Frame>
  );
}

// ============================================================
//  ENTREPRISE — entreprise-depense
// ============================================================
export function EntrepriseDepense() {
  return (
    <Frame accent="#059669">
      <rect x="0" y="40" width={W} height="80" fill="url(#grad-hero)" />
      <T x="40" y="80" size="22" w="700" color="white">🏢 Entreprise</T>
      <T x="40" y="102" size="13" color="#A7F3D0">Les Entreprises Tremblay · Année 2026</T>
      {["Dépenses", "Kilométrage", "Factures", "Mon entreprise"].map((t, i) => (
        <g key={t}>
          <rect x={40 + i * 175} y="140" width="165" height="34" rx="9" fill={i === 0 ? "#059669" : "white"} stroke={i === 0 ? "#059669" : "#E2E8F0"} />
          <T x={122 + i * 175} y="162" size="12" w="600" color={i === 0 ? "white" : "#475569"} anchor="middle">{t}</T>
        </g>
      ))}
      <Card x="40" y="196" w="720" h="480">
        <T x="70" y="230" size="15" w="700" color="#1E293B">Nouvelle dépense</T>
        <Input x="70" y="250" w="200" label="Date *" value="2026-09-12" />
        <Input x="290" y="250" w="200" label="Catégorie *" value="Fournitures de bureau" />
        <Input x="510" y="250" w="220" label="Fournisseur / magasin" value="Bureau en gros" />
        <Input x="70" y="310" w="200" label="Montant total payé *" value="114,98" />
        <rect x="290" y="322" width="440" height="30" rx="7" fill="#ECFDF5" stroke="#A7F3D0" />
        <T x="304" y="342" size="12" w="600" color="#065F46">☑ Taxes (TPS/TVQ) incluses sur le reçu</T>
        <Input x="70" y="370" w="200" label="TPS ($)" value="5,00" muted />
        <Input x="290" y="370" w="200" label="TVQ ($)" value="9,98" muted />
        <T x="510" y="392" size="11" color="#64748B">☐ Je ne suis pas certain des taxes —</T>
        <T x="510" y="406" size="11" color="#64748B">le cabinet vérifiera</T>
        <Input x="70" y="430" w="660" label="Commentaire" value="Cartouches d'encre + papier" />
        <rect x="70" y="490" width="660" height="90" rx="10" fill="#F8FAFC" stroke="#CBD5E1" strokeDasharray="6 4" />
        <T x="400" y="528" size="13" w="600" color="#475569" anchor="middle">📷 Photographier le reçu ou choisir une image</T>
        <T x="400" y="550" size="11" color="#94A3B8" anchor="middle">JPG, PNG, HEIC ou PDF — la photo est jointe à la dépense</T>
        <Pill x="600" y="610" w="130" label="💾 Enregistrer" fill="#059669" />
      </Card>
      <Card x="780" y="196" w="380" h="480">
        <T x="800" y="230" size="15" w="700" color="#1E293B">Mes dépenses 2026</T>
        {[["12 sept", "Bureau en gros", "114,98 $"], ["8 sept", "Essence — Ultramar", "72,40 $"], ["2 sept", "Bell — cellulaire", "89,60 $"], ["28 août", "Home Depot", "246,15 $"]].map(([d, n, a], i) => (
          <g key={i}>
            <line x1="780" y1={252 + i * 80} x2="1160" y2={252 + i * 80} stroke="#F1F5F9" />
            <rect x="800" y={266 + i * 80} width="44" height="44" rx="8" fill="#ECFDF5" />
            <T x="822" y={295 + i * 80} size="18" anchor="middle">🧾</T>
            <T x="856" y={284 + i * 80} size="13" w="600" color="#1E293B">{n}</T>
            <T x="856" y={302 + i * 80} size="11" color="#94A3B8">{d} · reçu photo joint</T>
            <T x="1140" y={290 + i * 80} size="13" w="700" color="#065F46" anchor="end">{a}</T>
          </g>
        ))}
        <rect x="800" y="590" width="340" height="60" rx="10" fill="#ECFDF5" stroke="#A7F3D0" />
        <T x="816" y="614" size="12" w="700" color="#065F46">Rappel</T>
        <T x="816" y="634" size="11" color="#065F46">Aucun rapport de taxes ici : votre cabinet s'en charge.</T>
      </Card>
    </Frame>
  );
}

export const PAIE_GUIDE_ILLUSTRATIONS = {
  "paie-employes":       PaieEmployes,
  "paie-feuille-temps":  PaieFeuilleTemps,
  "paie-documents":      PaieDocuments,
  "paie-das":            PaieDas,
  "entreprise-depense":  EntrepriseDepense,
};
